import { customerApi } from "../../utils/apiConfig";

export const getSevkiyatList = (payload) => {
  return customerApi.post("/getSevkiyatList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getSevkiyatPlanlamaList = (payload) => {
  return customerApi.post("/getSevkiyatPlanlamaList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getSevkiyatPlanlamaFarkAnaliz = (payload) => {
  return customerApi.post("/getSevkiyatPlanlamaFarkAnaliz", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const addSevkiyatList = (payload) => {
  return customerApi.post("/addSevkiyatList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const bulkSevkiyatList = (payload) => {
  return customerApi.post("/bulkSevkiyatList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteSevkiyatList = (payload) => {
  return customerApi.post("deleteSevkiyatList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateSevkiyatList = (payload) => {
  return customerApi.post("/updateSevkiyatList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
